import './button.styles.css';

const BUTTON_TYPES_CLASSES = {
    inverted: 'inverted-btn',
    link: 'link-btn'
}

const Button = ({ children, buttonType, className, borderRadius, minWidth , background ,  ...otherProps }) => {
    const customStyles = {
        borderRadius: borderRadius ? borderRadius : '3px',
        minWidth: minWidth ? minWidth:"18rem",

    };
    

    return (
        <button
            className={`button-container ${BUTTON_TYPES_CLASSES[buttonType]} ${className}`}
            style={customStyles}
            {...otherProps}
        >
            {children}
        </button>
    );
}

export default Button;
